import * as d3 from 'd3-selection'

/*
 * This adds the symbols used by the beaker
 */
export default (selection, chartId, series, width, height, ry) => {
  selection.each(function (d) {
    let radius = width / 2
      , body = `M 0,0
                a ${radius} ${-ry} 0 0 0 ${radius * 2} 0
                l 0,${height}
                a ${-radius} ${-ry} 0 0 1 ${-radius * 2} 0Z`
      , lid = `M 0,0
               a ${radius},${ry} 0,0,0 ${radius * 2} 0
               a ${radius},${ry} 0,0,0 ${-radius * 2} 0`
      , g = d3.select(this)
              .selectAll('g.beaker-symbols')
              .data([d])

    g = g.enter()
         .append('g')
         .attr('class', 'beaker-symbols')
         .merge(g)

    let symbol = g.selectAll('g.symbol') // Use a `g` because `symbol` elements cause issues with positioning
                  .data(() => {
                    return [{
                      id: `${chartId}-beaker-background`,
                      paths: [{
                        fill: `url(#${chartId}-beaker-background-a)`,
                        d: body
                      }, {
                        fill: `url(#${chartId}-beaker-background-b)`,
                        d: body
                      }, {
                        fill: `url(#${chartId}-beaker-lid-a)`,
                        d: lid
                      }, {
                        fill: `url(#${chartId}-beaker-lid-b)`,
                        stroke: `url(#${chartId}-beaker-lid-outline)`,
                        'stroke-width': 4,
                        d: lid
                      }]
                    }
                    , {
                      id: `${chartId}-beaker-foreground`,
                      paths: [{
                       fill: `url(#${chartId}-beaker-foreground-fill)`,
                       stroke: `url(#${chartId}-beaker-foreground-outline)`,
                       'stroke-width': 1,
                       d: body
                      }]
                    }
                    ]
                  })
                  .enter()
                  .append('g')
                  .attr('id', d => d.id)
                  .attr('class', 'symbol')
                  .merge(g.selectAll('g.symbol'))

    symbol.selectAll('path')
          .data(d => d.paths)
          .enter()
          .append('path')
          .merge(symbol.selectAll('path'))
          .select(function (d) {
            for (const [key, value] of Object.entries(d)) {
              d3.select(this).attr(key, value)
            }
            return this
          })
  })
}
